import { NgControl } from '@angular/forms';
import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[ngModel]',
})
export class NativeElementInjectorDirective implements OnInit {
  constructor(private el: ElementRef, private control: NgControl) {}

  ngOnInit() {
    (this.control.control as any).nativeElement = this.el.nativeElement;
  }
}
